import React from "react";
import Electrical from "../../Assets/Images/electric_copy.png";
import Steam from "../../Assets/Images/stream copy.png";
import Water from "../../Assets/Images/water copy.png";
import CompressedAir from "../../Assets/Images/compressor copy.png";
import Temperature from "../../Assets/Images/Temprature copy.png";
import graphic_circle from "../../Assets/Images/graphic circle copy.png";
import lock from "../../Assets/Images/lock-icon.png"
import { Link, useNavigate, useLocation } from "react-router-dom";
import { SettingOutlined, LockOutlined } from "@ant-design/icons";
import padlock from "../../Assets/Images/padlock.png"
import {
  LOGIN,
  LANDING,
  AR_NO_MATCH,
  CONFIGURATION_DASHBOARD,
} from "../../Common/Constants";
import { useSelector } from "react-redux";
// // Import your CSS file

const LandingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { modules: purchasedModules } = location.state || { modules: [] };
  console.log(purchasedModules);
  const loggedIn = useSelector((state)=>state.user)
    console.log(loggedIn)

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  console.log(isdarkMode)

  return (
  <>
      <div className={`flex justify-center items-center h-screen  ${isdarkMode ? 'landing-bg-img-dark' : 'landing-bg-img '}`}>
        <div className="flex justify-center items-center w-1/2">
          <div className="  w-[200px]  h-[200px]  sm:w-[250px] sm:h-[250px]  md:w-[300px] md:h-[300px]  lg:w-[400px] lg:h-[400px] rounded-full relative border-[4px] sm:border-[4px] md:border-[6px]  lg:border-[14px] landing-bigcircle-border flex justify-center items-center">
            
           

          <div className="absolute  -top-14 sm:-top-20 md:-top-24 lg:-top-24 filt ">
              {purchasedModules.includes("electrical") ? (
                // <Link to="https://wegindia.minnotra.in/aspx/login.aspx" target="_blank">
                <Link to="/electrical-dashboard" target="_blank">
                  <div className="cursor-pointer  animate">
                    <img src={graphic_circle} className="relative w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48" />
                    <img
                      src={Electrical}
                      className="absolute top-8 sm:top-10 md:top-12 lg:top-14  left-[40px] sm:left-[50px] md:left-[60px] lg:left-[75px] w-4 sm:w-6 md:w-8 lg:w-10"
                      alt="Electrical"
                    />
                    <p className="landing-font-color landing-circle-font text-xs sm:text-sm md:text-md sm:top-16 sm:left-10  md:top-20 md:left-12 lg:text-lg lg:top-24 lg:left-16">
                      Electrical
                    </p>
                  </div>
                </Link>
              ) : (
                <div className="relative  module-container module-container-temp icon-animate">
                  <img src={graphic_circle} className="relative w-48 h-48 icon-animate" />
                  <img
                    src={Electrical}
                    className="absolute top-14 left-[75px] w-10 icon-animate"
                    alt="Electrical"
                  />
                  {/* <LockOutlined className="absolute top-14 left-[75px] text-green-700 text-4xl module-icon mt-4" /> */}
                  <img
                    src={padlock}
                    className="absolute top-14 left-[75px] w-10 h-10 module-icon "
                    alt="padlock"
                  />
                   <p className="landing-font-color font-semibold absolute top-24 left-[75px] text-center icon-animate">
                    Electrical
                  </p>
                </div>
              )}
            </div>


            <div className="absolute -top-[10px] -right-12 sm:-right-20 md:-right-22 lg:-right-24 ">
              {purchasedModules.includes("steam") ? (
                <Link to="/steam-dashboard" target="_blank">
                  <div className="cursor-pointer animate">
                    <img src={graphic_circle} className="relative w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48" />
                    <img
                      src={Steam}
                      className="absolute top-8 sm:top-10 md:top-12 lg:top-14  left-[40px] sm:left-[50px] md:left-[60px] lg:left-[75px] w-4 sm:w-6 md:w-8 lg:w-10 "
                      alt="Steam"
                    />
                    <p className="landing-font-color font-semibold absolute text-xs sm:text-sm md:text-md top-12 left-8 sm:top-14 sm:left-10 sm:text-xs md:top-20 md:left-12 lg:text-lg lg:top-24 lg:left-16">
                      Steam
                    </p>
                  </div>
                </Link>
              ) : (
                <div className="relative  module-container module-container-temp icon-animate">
                  <img src={graphic_circle} className="relative w-48 h-48 icon-animate" />
                  <img
                    src={Steam}
                    className="absolute top-14 left-[75px] w-10 icon-animate"
                    alt="Steam"
                  />
                 
                  <img
                    src={padlock}
                    className="absolute top-14 left-[75px] w-10 h-10 module-icon "
                    alt="padlock"
                  />
                  <p className="landing-font-color font-semibold absolute top-24 left-[75px] text-center icon-animate">
                    Steam
                  </p>
                </div>
              )}
            </div>


            <div className="absolute   top-[110px] sm:top-[130px] md:top-[150px] lg:top-[175px]  -right-10 sm:-right-20 md:-right-22 lg:-right-24 ">
              {purchasedModules.includes("water") ? (
                <Link to="/water-dashboard" target="_blank">
                  <div className="cursor-pointer animate">
                    <img src={graphic_circle} className="relative w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48" />
                    <img
                      src={Water}
                      className="absolute top-8 sm:top-10 md:top-12 lg:top-14  left-[40px] sm:left-[50px] md:left-[60px] lg:left-[75px] w-4 sm:w-6 md:w-8 lg:w-10"
                      alt="Water"
                    />
                    <p className="landing-font-color font-semibold absolute text-xs sm:text-sm md:text-md top-14 left-8 sm:top-16 sm:left-10 sm:text-xs md:top-20 md:left-12  lg:text-lg lg:top-24 lg:left-16">
                      Water
                    </p>
                  </div>
                </Link>
              ) : (
                <div className="relative  module-container module-container-temp icon-animate">
                  <img src={graphic_circle} className="relative w-48 h-48 icon-animate" />
                  <img
                    src={Water}
                    className="absolute top-14 left-[75px] w-10 icon-animate"
                    alt="Water"
                  />
                  <img
                    src={padlock}
                    className="absolute top-14 left-[75px] w-10 h-10 module-icon "
                    alt="padlock"
                  />
                  <p className="landing-font-color font-semibold absolute top-24 left-[70px] text-center icon-animate">
                    Water
                  </p>
                </div>
              )}
            </div>
          

            <div className="absolute top-[160px]  sm:top-[190px] md:top-[240px] lg:top-[270px] sm:right-14  md:right-18 lg:right-20  ">
              {purchasedModules.includes("configuration") ? (
                <Link to={CONFIGURATION_DASHBOARD} target="_blank">
                  <div className="cursor-pointer animate">
                    <img src={graphic_circle} className="relative w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48" />
                    <SettingOutlined className="absolute text-lime-500 text-2xl top-8 sm:top-10 md:top-12 lg:top-14  left-[40px] sm:left-[50px] md:left-[60px] lg:left-[70px] w-4 sm:w-6 md:w-8 lg:w-10" />
                    <p className="landing-font-color font-semibold absolute text-sm sm:text-sm md:text-md top-14 left-6  sm:top-16 sm:left-8 sm:text-xs md:top-20 md:left-12  lg:text-lg lg:top-24 lg:left-10">
                      Configuration
                    </p>
                  </div>
                </Link>
              ) : (
                <div className="relative  module-container module-container-temp icon-animate">
                  <img src={graphic_circle} className="relative w-48 h-48 icon-animate" />
                  <SettingOutlined className="absolute text-lime-500 text-2xl top-[60px] left-[75px] w-10 icon-animate" />
                  <img
                    src={padlock}
                    className="absolute top-14 left-[75px] w-10 h-10 module-icon "
                    alt="padlock"
                  />
                  <p className="landing-font-color font-semibold absolute top-24 left-[50px] icon-animate">
                    Configuration
                  </p>
                </div>
              )}
            </div>

            <div className="absolute top-[90px] sm:top-[110px] md:top-[160px] lg:top-[170px]   -left-12 sm:-left-16  md:-left-20 lg:-left-20  ">
              {purchasedModules.includes("air") ? (
                <Link to="/air-dashboard" target="_blank">
                  <div className="cursor-pointer animate">
                    <img src={graphic_circle} className="relative w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48" />
                    <img
                      src={CompressedAir}
                      className="absolute top-8 sm:top-10 md:top-12 lg:top-14  left-[40px] sm:left-[50px] md:left-[60px] lg:left-[75px] w-4 sm:w-6 md:w-8 lg:w-10"
                      alt="Compressed Air"
                    />
                    <p className="landing-font-color font-semibold absolute  text-sm sm:text-sm md:text-md top-12 left-6 sm:top-16 sm:left-8 sm:text-xs md:top-20 md:left-12  lg:text-lg lg:top-24 lg:left-10 pr-10 text-center">
                      Compressed Air
                    </p>
                  </div>
                </Link>
              ) : (
                <div className="relative  module-container module-container-temp icon-animate">
                <img src={graphic_circle} className="relative w-48 h-48 icon-animate"/>
                <img
                  src={CompressedAir}
                  className="absolute top-14 left-[75px] w-10 icon-animate"
                  alt="CompressedAir"
                />
             <img
                    src={padlock}
                    className="absolute top-14 left-[75px] w-10 h-10 module-icon "
                    alt="padlock"
                  />
                <p className="landing-font-color font-semibold absolute top-24 left-[50px] pr-10 text-center icon-animate">
                Compressed Air
                </p>
              </div>
              )}
            </div>

            <div className="absolute -top-1 -left-12 sm:-top-2 md:-top-4 lg:-top-4 sm:-left-16 md:-left-20 lg:-left-20  ">
              {purchasedModules.includes("temperature") ? (
                <Link to="/temperature-dashboard" target="_blank">
                  <div className="cursor-pointer animate icon-animate">
                    <img src={graphic_circle} className="relative w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 " />
                    <img
                      src={Temperature}
                      className="absolute top-8 sm:top-10 md:top-12 lg:top-14  left-[40px] sm:left-[50px] md:left-[60px] lg:left-[75px] w-4 sm:w-6 md:w-8 lg:w-10"
                      alt="Temperature"
                    />
                    <p className="landing-font-color font-semibold absolute  text-sm sm:text-sm md:text-md top-12 left-6 sm:top-16 sm:left-8 sm:text-xs md:top-20 md:left-12  lg:text-lg lg:top-24 lg:left-10">
                      Temperature
                    </p>
                  </div>
                </Link>
              ) : (
                <div className="relative  module-container module-container-temp icon-animate">
                  <img src={graphic_circle} className="relative w-48 h-48 icon-animate"/>
                  <img
                    src={Temperature}
                    className="absolute top-14 left-[75px] w-10 icon-animate"
                    alt="Temperature"
                  />
                  {/* <LockOutlined className="absolute top-14 left-[75px] text-gray-500 text-4xl module-icon text-center mt-4" /> */}
                  <img
                    src={padlock}
                    className="absolute top-14 left-[75px] w-10 h-10 module-icon "
                    alt="padlock"
                  />
                  <p className="landing-font-color font-semibold absolute top-24 left-[50px] pr-10 text-center icon-animate">
                    Temperature
                  </p>
                </div>

    

              )}
            </div>





            <div className="landing-center-color  w-[120px] h-[120px] sm:w-[140px] sm:h-[140px]  md:w-[150px] md:h-[150px]  lg:w-[180px] lg:h-[180px] rounded-full shadow-xl flex justify-center items-center">
              <div className="landing-center-color w-[100px] h-[100px] sm:w-[120px] sm:h-[120px]  md:w-[135px] md:h-[135px] lg:w-[165px] lg:h-[165px] text-xs sm:text-sm md:text-base font-semibold text-white flex justify-center items-center rounded-full border-[1px] border-white">
                Expert Trax-EMS
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;





